var $ = global.jQuery = global.$;

var _Base = require('./_Base');
var IconToggle = _Base.extend({
  init: function() {
    this.classes = {
      icon: 'icon--' + this.$el.data('icon'),
      iconAlt: 'icon--' + this.$el.data('iconAlt')
    };

    this.$el.addClass(this.classes.icon);

  },

  toggle: function() {
    if (this.$el.hasClass(this.classes.icon)) {
      this.$el.addClass(this.classes.iconAlt);
      this.$el.removeClass(this.classes.icon);
    } else if (this.$el.hasClass(this.classes.iconAlt)) {
      this.$el.addClass(this.classes.icon);
      this.$el.removeClass(this.classes.iconAlt);
    }
  }
});

module.exports = IconToggle;



//////////////////
// WEBPACK FOOTER
// ./source/scripts/widgets/IconToggle_PTS.js
// module id = 285
// module chunks = 1